import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Table from 'components/table/Table'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchCreative,
  importCreative,
  resetCreativeDetail,
  setSearchResult,
  setSearchText,
  setSelectedCreative,
} from 'features/creative/add/import/creativeImportSlice'
import SearchInput from 'components/form/SearchInput'
import ImportPreview from 'features/creative/add/import/ImportPreview'
import classNames from 'classnames'
import { useHistory, useParams } from 'react-router-dom'
import { ReviewStatus } from 'features/Codes'
import { useConfirm } from 'features/dialog/Confirm'
import NoneAnchor from 'components/NoneAnchor'
import { setImportedId } from 'features/creative/add/creativeAddSlice'
import { setChannel } from '../build/buildCreativeSlice'

const CreativeImport = ({ readOnly }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { accountId } = useParams()
  const {
    creativeAdd: { selectedChannel: channel, creatives },
    creativeImport: {
      creativeDetail,
      selectedCreative,
      searchText,
      searchResult,
      loading,
    },
  } = useSelector(state => state.creative)
  const [CancelCreativeImport, showCancelCreativeImport] = useConfirm()

  useEffect(() => {
    dispatch(setSearchResult(creatives))
  }, [creatives, dispatch])

  useEffect(() => {
    dispatch(setSelectedCreative(null))
    dispatch(resetCreativeDetail())
  }, [dispatch])

  useEffect(() => {
    if (selectedCreative) {
      dispatch(fetchCreative())
    }
  }, [selectedCreative, dispatch])

  const handleBackToList = () => history.push(`/${accountId}/creatives`)
  const handleCreativeImport = async () => {
    dispatch(setImportedId(creativeDetail.id))
    await importCreative({
      creative: creativeDetail,
      channel,
      dispatch,
    })
    history.push(`/${accountId}/creatives/add`)
  }
  const handleCreativeAddClick = () => {
    dispatch(setChannel(channel))
    history.push(`/${accountId}/creatives/add`)
  }
  return (
    <>
      <div className="material_detail material_existing">
        <div className="top_material">
          <div className="tit_material">
            <h3 className="subtit_subject">소재 등록</h3>
            <ul className="tap_complete">
              <li>
                <NoneAnchor
                  className="btn_complete"
                  onClick={handleCreativeAddClick}>
                  <span className="inner_g">
                    <span className="ico_comm" />새 소재
                  </span>
                </NoneAnchor>
              </li>
              <li className="on">
                <NoneAnchor className="btn_complete">
                  <span className="inner_g">
                    <span className="ico_comm" />
                    기존 소재 불러오기
                  </span>
                </NoneAnchor>
              </li>
            </ul>
          </div>
        </div>
        <div className="cont_material">
          <div className="group_material">
            <div className="box_material">
              <div className="inner_material">
                <strong className="tit_existing">
                  등록된 소재<em className="fc_emph"> {creatives.length}</em>
                </strong>
                <div className="search_complete">
                  <div className="inner_complete">
                    <SearchInput
                      placeholder="소재 이름을 검색하세요"
                      value={searchText}
                      disabled={channel === null}
                      onValueChange={v => dispatch(setSearchText(v))}
                      onSearch={() =>
                        dispatch(
                          setSearchResult(
                            creatives.filter(c =>
                              c.creativeName.includes(searchText)
                            )
                          )
                        )
                      }
                    />
                  </div>
                </div>
                <div className="table_scroll">
                  <div className="item_head">
                    <div className="inner_table">
                      <Table className="tbl_g2" caption="데이터 테이블">
                        <Table.Head>
                          <Table.Column title="소재 이름" width={429} />
                          <Table.Column title="심사 상태" />
                        </Table.Head>
                      </Table>
                    </div>
                  </div>
                  <div className="item_body">
                    <div className="inner_table">
                      <Table
                        className="tbl_g2"
                        caption="데이터 테이블"
                        emptyMessage={
                          creatives.length === 0
                            ? '등록된 소재가 없습니다.'
                            : '검색결과가 없습니다.'
                        }
                        loading={loading}>
                        <Table.Head noHead>
                          <Table.Column width={429} />
                          <Table.Column />
                        </Table.Head>
                        <Table.Body>
                          {searchResult.map(creative => (
                            <Table.Row key={creative.id} rowId={creative.id}>
                              <td
                                onClick={() =>
                                  dispatch(setSelectedCreative(creative))
                                }>
                                <div className="inner_tbl">
                                  {creative.creativeName}
                                </div>
                              </td>
                              <td>
                                <div className="inner_tbl">
                                  {ReviewStatus[creative.reviewStatus].title}
                                </div>
                              </td>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ImportPreview />
          </div>
        </div>
      </div>
      <div className="page_btn">
        <div className="inner_btn">
          {!readOnly && (
            <button
              type="button"
              className="btn_gm"
              onClick={showCancelCreativeImport}>
              <span className="inner_g">취소</span>
            </button>
          )}
          <button
            type="button"
            className={classNames('btn_gm gm_bl', {
              in_active: !selectedCreative,
            })}
            onClick={readOnly ? handleBackToList : handleCreativeImport}>
            <span className="inner_g">{readOnly ? '확인' : '불러오기'}</span>
          </button>
        </div>
        <CancelCreativeImport
          title="소재등록 취소"
          onClose={({ isConfirmed }) => isConfirmed && handleBackToList()}>
          <>
            소재등록을 취소하시겠습니까?
            <br />
            저장되지 않은 모든 내용은 사라집니다.
          </>
        </CancelCreativeImport>
      </div>
    </>
  )
}

export default CreativeImport

CreativeImport.propTypes = {
  readOnly: PropTypes.bool,
}
